export default "__VITE_PUBLIC_ASSET__c5c4dc31__"